module.exports = __webpack_public_path__ + "assets/img/36_1509_big.21b94d55.jpg";